/** Capitalize the first letter of each word (e.g. "chetan chumble" → "Chetan Chumble"). */
export function capitalizeName(value: string): string {
  if (!value || typeof value !== 'string') {
    return value;
  }

  return value
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/** Format first + last name for display with consistent capitalization. */
export function formatPersonName(
  firstName?: string | null,
  lastName?: string | null,
  fallback = 'N/A'
): string {
  const parts = [firstName, lastName]
    .filter((part) => part != null && String(part).trim() !== '')
    .map((part) => capitalizeName(String(part)));

  return parts.length ? parts.join(' ') : fallback;
}
